var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initObject = void 0;

function initObject(path, config) {
  const importedClass = require("../discovery/" + path);

  return new importedClass.default(config);
}

exports.initObject = initObject; //# sourceMappingURL=initObject.js.map

export default exports;